/**
 * Exclusive accordion.
 *
 * <details name="..."> already does this natively in current browsers; this
 * closes the others wherever that attribute is not yet supported, so the
 * behaviour is the same everywhere.
 */
class RanaAccordion extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('details'));
    if (this.items.length < 2) return;

    // Nothing to do where the browser enforces the group itself.
    const probe = document.createElement('details');
    if ('name' in probe) return;

    this.onToggle = (event) => {
      const opened = event.target;
      if (!opened.open) return;
      for (const item of this.items) {
        if (item !== opened) item.open = false;
      }
    };

    for (const item of this.items) {
      item.addEventListener('toggle', this.onToggle);
    }
  }

  disconnectedCallback() {
    if (!this.onToggle) return;
    for (const item of this.items) {
      item.removeEventListener('toggle', this.onToggle);
    }
  }
}

if (!customElements.get('rana-accordion')) {
  customElements.define('rana-accordion', RanaAccordion);
}
